export const collapseGroups = (groupDefinitions, singular, plural, emptyText, countOnly = false) => {
    return (groups) => {
        if (!groups || groups.length === 0) {
            return emptyText;
        }
        const nonGroupedItems = groups.filter(g => !groupDefinitions.has(g));
        const groupedItems = groups.filter(g => groupDefinitions.has(g));
        const words = [];
        if (groupedItems.includes('*')) {
            words.push(groupDefinitions.get('*') || '');
            if (groupedItems.length - 1 > 0) {
                words.push(`${groupedItems.length - 1} group${groupedItems.length - 1 > 1 ? 's' : ''}`);
            }
        }
        else {
            if (groupedItems.length === 1) {
                words.push(groupDefinitions.get(groupedItems[0]) || '');
            }
            else if (groupedItems.length > 1) {
                words.push(`${groupedItems.length} groups`);
            }
        }
        if (nonGroupedItems.length > 0) {
            if (countOnly) {
                words.push(`${nonGroupedItems.length} ${nonGroupedItems.length === 1 ? singular : plural}`);
            }
            else {
                if (groupedItems.length > 0) {
                    words.push(`${nonGroupedItems.length} ${nonGroupedItems.length === 1 ? singular : plural}`);
                }
                else {
                    words.push(`${nonGroupedItems[0]}`);
                    if (nonGroupedItems.length > 1) {
                        words.push(`${nonGroupedItems.length - 1} ${nonGroupedItems.length - 1 === 1 ? singular : plural}`);
                    }
                }
            }
        }
        if (words.length == 0) {
            return emptyText;
        }
        return words.join(' and ');
    };
};
export const getAircraftRegistrationLabel = (aircraft, emptyText = '') => {
    const groupDefinitions = new Map([
        ['*', 'All aircraft'],
        ['FIXED_WING', 'All fixed wing'],
        ['ROTARY_WING', 'All rotary wing']
    ]);
    return collapseGroups(groupDefinitions, 'aircraft', 'aircraft', emptyText, true)(aircraft);
};
export const getAircraftRegistrationVerboseLabel = (aircraft, emptyText = '') => {
    const groupDefinitions = new Map([
        ['*', 'All aircraft'],
        ['FIXED_WING', 'All fixed wing'],
        ['ROTARY_WING', 'All rotary wing']
    ]);
    return collapseGroups(groupDefinitions, 'more', 'more', emptyText, false)(aircraft);
};
export const getUsersLabel = (users, emptyText = '') => {
    const groupDefinitions = new Map([
        ['*', 'All users'],
        ['ADMINS', 'All admin users']
    ]);
    return collapseGroups(groupDefinitions, 'user', 'users', emptyText, false)(users);
};
export const getEventsLabel = (rules, emptyText = '') => {
    const groupDefinitions = new Map([['*', 'All events']]);
    return collapseGroups(groupDefinitions, 'event', 'events', emptyText, true)(rules);
};
export const getGeofenceLabel = (rules, emptyText = '') => {
    const groupDefinitions = new Map([['*', 'All geofences']]);
    return collapseGroups(groupDefinitions, 'more', 'more', emptyText, false)(rules);
};
export const getExceedanceLabel = (rules, emptyText = '') => {
    const groupDefinitions = new Map([['*', 'All exceedances']]);
    return collapseGroups(groupDefinitions, 'more', 'more', emptyText, false)(rules);
};
export const getRuleLabel = (rules, emptyText = '') => {
    const groupDefinitions = new Map([['*', 'All rules']]);
    return collapseGroups(groupDefinitions, 'more', 'more', emptyText, false)(rules);
};
export const getUserGroupsLabel = (groups, emptyText = '') => {
    const groupDefinitions = new Map([
        ['*', 'All users'],
        ['ADMINS', 'All admins']
    ]);
    return collapseGroups(groupDefinitions, 'more', 'more', emptyText, false)(groups);
};
